// App entry point. Loads global styles (single pipeline: raw M3 fig tokens →
// app-chrome tokens → Material Web aliases), registers the design-system
// components, defines <bc-app>, and installs the Workbox service worker.
import './styles/tokens.css';
import './lib/printsheet.css';
import './app';
import './components/pwa-prompt';
import { registerSW } from 'virtual:pwa-register';
import type { PwaPrompt } from './components/pwa-prompt';

// Mount the install/update prompt.
const prompt = document.createElement('pwa-prompt') as PwaPrompt;
document.body.appendChild(prompt);

/**
 * Register the Workbox service worker.
 *
 * registerType is 'autoUpdate' (see vite.config.ts): a new worker skips waiting
 * and claims its clients, so a returning visitor gets the current build instead
 * of whatever was cached the first time they came. That was not a preference —
 * under the previous 'prompt' setting the fix could never reach the people who
 * needed it, since the code that would have shown them the prompt was itself
 * the stale copy.
 */
const updateSW = registerSW({
  onRegisteredSW(_url, reg) {
    // A tab left open for days would otherwise never ask again.
    if (reg) setInterval(() => void reg.update(), 60 * 60 * 1000);
  },
  onOfflineReady() {
    // The app shell is cached; the collected directory renders from IndexedDB.
  },
});
void updateSW;
